import { gql } from "@apollo/client";

// Appraisals (see wfc-server service/appraisalService). Every response is
// { message, response } with response as JSON.

export const getAppraisalSettingsQuery = gql`
    query getAppraisalSettings{
        getAppraisalSettings{
            message
            response
        }
    }
`;

export const getAppraisalOverviewQuery = gql`
    query getAppraisalOverview{
        getAppraisalOverview{
            message
            response
        }
    }
`;

export const getAppraisalsQuery = gql`
    query getAppraisals($filter: AppraisalListFilter){
        getAppraisals(filter: $filter){
            message
            response
        }
    }
`;

export const getAppraisalQuery = gql`
    query getAppraisal($id: String!){
        getAppraisal(id: $id){
            message
            response
        }
    }
`;

export const getAppraisalReviewersQuery = gql`
    query getAppraisalReviewers($employeeId: String!, $reviewerRole: String){
        getAppraisalReviewers(employeeId: $employeeId, reviewerRole: $reviewerRole){
            message
            response
        }
    }
`;

export const getAppraisalRecordUrlQuery = gql`
    query getAppraisalRecordUrl($id: String!){
        getAppraisalRecordUrl(id: $id){
            message
            response
        }
    }
`;

// appraisals set up to open later and/or repeat - one employee's, or everyone's
export const getAppraisalSchedulesQuery = gql`
    query getAppraisalSchedules($employeeId: String){
        getAppraisalSchedules(employeeId: $employeeId){
            message
            response
        }
    }
`;
